import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type dashboardAdminPermissionType = 'dashboard_admin_view';

export const dashboardAdminPermissionMatrix: IPermissionMatrix<dashboardAdminPermissionType> = {
  dashboard_admin_view: [UserRole.admin]
};
